import { useEffect, useRef } from 'react';

export const INTERVALLO_AGGIORNAMENTO_MS = 10 * 1000;
const PAUSA_MINIMA_MS = 1500;   // focus e visibilitychange arrivano quasi insieme: un solo caricamento

// Richiama `carica` ogni 10 secondi (con un piccolo scarto casuale, così i browser aperti insieme non partono tutti nello stesso istante) e
// subito quando si torna sulla scheda o sulla finestra del browser, così gli elenchi mostrano le modifiche degli altri operatori.
// Si ferma quando la scheda del browser è nascosta o quando `attivo` è false (es. finestra di modifica aperta), per non toccare quello che
// l'utente sta scrivendo. NON è la protezione contro le sovrascritture: quella è la versione (vista) di ogni riga, indipendente dal tempo.
export default function useAggiornamentoPeriodico(carica, { attivo = true, intervallo = INTERVALLO_AGGIORNAMENTO_MS } = {}) {
  const caricaRef = useRef(carica);
  caricaRef.current = carica;

  useEffect(() => {
    if (!attivo) return undefined;
    let ultimo = 0;
    const esegui = () => {
      if (document.visibilityState !== 'visible') return;
      const ora = Date.now();
      if (ora - ultimo < PAUSA_MINIMA_MS) return;
      ultimo = ora;
      caricaRef.current();
    };
    const id = setInterval(esegui, intervallo + Math.round(Math.random() * 1000));
    document.addEventListener('visibilitychange', esegui);   // scheda del browser
    window.addEventListener('focus', esegui);                // finestra del browser
    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', esegui);
      window.removeEventListener('focus', esegui);
    };
  }, [attivo, intervallo]);
}
